import { GestionHeader } from "./SiteHeader";
import InvoicesPanel from "./InvoicesPanel";
import "./MyAccount.css";

// Page Facturations du menu burger : les factures du commerce du gérant.
function Billing({ user, onNavigate, onLogout }) {
  return (
    <div className="acct-container">
      <GestionHeader
        user={user}
        onNavigate={onNavigate}
        title="Facturations"
        onBack={() => onNavigate("home")}
        onHome={() => onNavigate("home")}
        onLogout={onLogout}
      />
      <main className="acct-main acct-main-wide">
        <InvoicesPanel />
      </main>
    </div>
  );
}

export default Billing;
